// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606040158/js/" + chunkId + "." + {"44":"0f0c7e41","225":"07a5e966","481":"c43566d2","486":"d03a7113","770":"d027e615"}[chunkId] + ".0.03415622460727241.chunk.js";
};